import { useEffect } from "react";
import { useFlashMessageActions } from "utils/context/FlashMessageContext";

export default function useFlashMessage () {
  const [,{closeFlashMessage}] = useFlashMessageActions();
  useEffect(()=> {
    closeFlashMessage();
  },[])
}
